import { render, staticRenderFns } from "./GlobalPartnersRegionDetailView.vue?vue&type=template&id=3dd50c74&scoped=true"
import script from "./GlobalPartnersRegionDetailView.vue?vue&type=script&lang=js"
export * from "./GlobalPartnersRegionDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd50c74",
  null
  
)

export default component.exports